import { useEffect } from 'react';

// Locks background <body> scroll while a modal is mounted, so scrolling the
// overlay scrolls the modal (not the page behind it). Restores on unmount.
export function useBodyScrollLock(enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined;
    const original = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = original;
    };
  }, [enabled]);
}
